import { NominatimAddress } from "@/models/nominatim/reverse/nominatimAddress";
import { NominatimReverseResponse } from "@/models/nominatim/reverse/nominatimReverseResponse";
import { NominatimHttpService } from "@/services/location/nominatimHttpService";

export const locationStore = {
     namespaced: true,
   
     state: {
          address: ''
     },
   
     getters: {
          address: (state: any) => state.address,
     },
   
     mutations: {
          setAddress(state: any, value: string) {
               state.address = value;
          },
     },
   
     actions: {
          async getLocationDetailsByCoordinates({ commit }: any, { latitude, longitude }: { latitude: number, longitude: number}): Promise<NominatimReverseResponse> {
               const locationDetails = await NominatimHttpService.getLocationDetails(latitude, longitude);

               const address = buildAddress(locationDetails.address);
               commit('setAddress', address);

               return locationDetails;
          },
     },
};

const addSeparator = (value: string | undefined, separator: string): string => {
     return value ? value + separator : "";
}

const buildAddress = (address: NominatimAddress): string => {
     const houseNumber = addSeparator(address.house_number, " ");
     const road = addSeparator(address.road, ", ");
     const city = addSeparator(address.city, ", ");
     const country = addSeparator(address.country, "");

     return `${houseNumber}${road}${city}${country}`;
}